import { render, staticRenderFns } from "./ShowLesson.vue?vue&type=template&id=3d4dfb2e&"
import script from "./ShowLesson.vue?vue&type=script&lang=js&"
export * from "./ShowLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports